/**
 * Rotten Charm — Product Card quick-add
 * Delegated at the document level so it works for any number of product
 * cards on a page (grids, carousels, collection pages) without re-binding.
 * Relies on window.RottenCart, exposed by component-cart-drawer.js.
 */
(function () {
  'use strict';

  const RESET_DELAY = 1800;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-rc-quick-add]');
    if (!btn) return;

    if (!window.RottenCart) {
      console.error('Rotten Charm: cart drawer not initialized yet.');
      return;
    }

    const variantId = btn.dataset.variantId;
    const label = btn.querySelector('[data-rc-quick-add-label]');
    const originalText = label ? label.textContent : '';

    btn.dataset.state = 'loading';
    if (label) label.textContent = window.rcStrings?.updating || 'Adding...';

    window.RottenCart.addItem(variantId, 1)
      .then(() => {
        btn.dataset.state = 'added';
        if (label) label.textContent = window.rcStrings?.added || 'Added ✓';
        setTimeout(() => {
          btn.dataset.state = '';
          if (label) label.textContent = originalText;
        }, RESET_DELAY);
      })
      .catch(() => {
        btn.dataset.state = 'error';
        if (label) label.textContent = window.rcStrings?.cartError || 'Try again';
        setTimeout(() => {
          btn.dataset.state = '';
          if (label) label.textContent = originalText;
        }, RESET_DELAY);
      });
  });
})();
